import { render, staticRenderFns } from "./templateBodypart.vue?vue&type=template&id=03b448ef&scoped=true"
import script from "./templateBodypart.vue?vue&type=script&lang=js"
export * from "./templateBodypart.vue?vue&type=script&lang=js"
import style0 from "./templateBodypart.vue?vue&type=style&index=0&id=03b448ef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b448ef",
  null
  
)

export default component.exports